module.exports = __webpack_public_path__ + "img/kerala_periyar_camp.c39ccbbf.jpg";